import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as ArchiveService from '_services/archive-service';

const initialState = {
    archives: [],
    selectedArchive: null,
    createStatus: 'idle',
    view: 'list',
};

export const createArchive = createAsyncThunk(
    "archive/createArchive",
    async (data) => {
        return await ArchiveService.createArchive(data);
    }
);

const archiveSlice = createSlice({
    name: 'archive',
    initialState,
    reducers: {
        reset: () => initialState,
        setArchives: (state, action) => {
            state.archives = action.payload;
        },
        setSelectedArchive: (state, action) => {
            state.selectedArchive = action.payload;
        },
        setView: (state, action) => {
            state.view = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createArchive.pending, (state) => {
                state.createStatus = 'loading';
            })
            .addCase(createArchive.fulfilled, (state) => {
                state.createStatus = 'succeeded';
                state.view = 'list';
            })
            .addCase(createArchive.rejected, (state) => {
                state.createStatus = 'failed';
            });
    },
});

export const { reset, setArchives, setSelectedArchive, setView } = archiveSlice.actions;

export const selectArchives = (state) => state.archive.archives;
export const selectSelectedArchive = (state) => state.archive.selectedArchive;
export const selectView = (state) => state.archive.view;
export const selectCreateStatus = (state) => state.archive.createStatus;

export default archiveSlice.reducer;
